import {TableHead, TableRow, TableCell, Checkbox, Box} from "@mui/material";
import SortableFilterableHeaderCell from "../headerCells/SortableFilterableHeaderCell";
import NumberComparisonFilterHeader from "../headerCells/NumberComparisonFilterHeader";
import SelectFilterableHeaderCell from "../headerCells/SelectFilterableHeaderCell";
import CustomCheckbox from "../../../../../../../components/Checkbox";

export const MultiplierHeader = ({
    hotelOrGroupType,
    allSelected,
    someSelected,
    onSelectAll,
    sortConfig,
    onSortChange,
    filters,
    onFilterChange,
    data,
    hasDeletableRow
}) => (
    <TableHead>
        <TableRow>
            <TableCell>
                <Box display="flex" alignItems="center">
                    {hasDeletableRow && (
                        <CustomCheckbox
                            checked={allSelected}
                            onChange={onSelectAll}
                            checkboxStyles={{ padding: "2px 0 2px 9px" }}
                        />
                    )}
                    <SortableFilterableHeaderCell
                        label={`${hotelOrGroupType} Name`}
                        columnKey="label_entity"
                        sortConfig={sortConfig}
                        onSortChange={onSortChange}
                        filterValue={filters.label_entity}
                        onFilterChange={onFilterChange}
                        disableFilter={true}
                        hasCheckBox={hasDeletableRow}
                    />
                </Box>
            </TableCell>
            <TableCell>
                <SelectFilterableHeaderCell
                    label="Device"
                    columnKey="label_device"
                    sortConfig={sortConfig}
                    onSortChange={onSortChange}
                    filterValue={filters.label_device}
                    onFilterChange={onFilterChange}
                    options={[...new Set(data?.map(row => row.label_device))]}
                />
            </TableCell>
            <TableCell>
                <SelectFilterableHeaderCell
                    label="Breakdown"
                    columnKey="label_breakdown"
                    sortConfig={sortConfig}
                    onSortChange={onSortChange}
                    filterValue={filters.label_breakdown}
                    onFilterChange={onFilterChange}
                    options={[...new Set(data?.map(row => row.label_breakdown))]}
                />
            </TableCell>
            <TableCell>
                <NumberComparisonFilterHeader
                    label="Multiplier Adjustment"
                    columnKey="multiplier_value"
                    sortConfig={sortConfig}
                    onSortChange={onSortChange}
                    filterValue={filters.multiplier_value}
                    onFilterChange={onFilterChange}
                />
            </TableCell>
            <TableCell />
        </TableRow>
    </TableHead>
);
